module.exports = __webpack_public_path__ + "static/img/za.ae23c355.svg";